const getRandomNumber = (min: number, max: number) => {
  if (min > max) {
    throw Error('min must be < max')
  }
  const randomNumber = Math.floor(Math.random() * (max - min) + min)
  return randomNumber
}

export default getRandomNumber
